export async function DeleteAulaIdProjecteIdTasca(id_aula: string, id_projecte: string, id_tasca: string) {
    const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/aules/${id_aula}/projectes/${id_projecte}/tasques/${id_tasca}`, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });

    if (response.ok) {
        return true;
    } else {
        return null;
    }
}
